export function isXeroPushFailed(response, json) {
  if (!response?.ok) return true;
  if (!json || typeof json !== 'object') return false;
  if (json.success === false) return true;
  if (String(json.success ?? '').toLowerCase() === 'false') return true;
  const httpStatus = Number(json.http_status);
  if (httpStatus >= 400) return true;
  const updated =
    json.xero_credit_updated ??
    json.xero_credit_note_updated ??
    json.xero_invoice_updated;
  if (updated === false && (json.raw || json.message || json.error)) return true;
  return false;
}

export function getXeroPushErrorMessage(json, fallback = 'Failed to push') {
  if (!json || typeof json !== 'object') {
    return fallback;
  }
  const parts = [];
  const direct = String(
    json.message ?? json.error ?? json.msg ?? json.error_message ?? ''
  ).trim();
  if (
    direct &&
    direct.toLowerCase() !== 'false' &&
    direct.toLowerCase() !== 'true'
  ) {
    parts.push(direct);
  }
  if (Array.isArray(json.errors)) {
    json.errors.forEach((item) => {
      if (typeof item === 'string' && item.trim()) parts.push(item.trim());
      else if (item?.Message) parts.push(String(item.Message).trim());
      else if (item?.message) parts.push(String(item.message).trim());
    });
  }
  const raw = json.raw;
  if (raw && typeof raw === 'object') {
    const topMsg = String(raw.Message ?? raw.message ?? '').trim();
    if (topMsg) parts.push(topMsg);
    const elements = Array.isArray(raw.Elements) ? raw.Elements : [];
    elements.forEach((el) => {
      if (!el || typeof el !== 'object') return;
      if (Array.isArray(el.ValidationErrors)) {
        el.ValidationErrors.forEach((v) => {
          const m = String(v?.Message ?? v?.message ?? '').trim();
          if (m) parts.push(m);
        });
      }
      if (el.Contact && Array.isArray(el.Contact.ValidationErrors)) {
        el.Contact.ValidationErrors.forEach((v) => {
          const m = String(v?.Message ?? v?.message ?? '').trim();
          if (m) parts.push(m);
        });
      }
      if (Array.isArray(el.LineItems)) {
        el.LineItems.forEach((li) => {
          if (!Array.isArray(li?.ValidationErrors)) return;
          li.ValidationErrors.forEach((v) => {
            const m = String(v?.Message ?? v?.message ?? '').trim();
            if (m) parts.push(m);
          });
        });
      }
    });
  }
  const unique = [...new Set(parts.filter(Boolean))];
  if (unique.length) return unique.join('. ');
  const ref = String(
    json.reference_no ?? json.return_no ?? json.invoice_no ?? ''
  ).trim();
  const httpStatus = Number(json.http_status);
  if (httpStatus >= 400 && ref) {
    return `${fallback} (${ref}) — HTTP ${httpStatus}`;
  }
  if (httpStatus >= 400) {
    return `${fallback} — HTTP ${httpStatus}`;
  }
  if (ref) return `${fallback} ${ref}`;
  return fallback;
}
